import { render, staticRenderFns } from "./author-user-list.html?vue&type=template&id=d61a1cd8&scoped=true&"
import script from "./author-user-list.js?vue&type=script&lang=js&"
export * from "./author-user-list.js?vue&type=script&lang=js&"
import style0 from "./author-user-list.scss?vue&type=style&index=0&id=d61a1cd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61a1cd8",
  null
  
)

export default component.exports